import React, { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from './ui/dialog';
import { Button } from './ui/button';
import { Money, CreditCard, Coins, Receipt, HandHeart } from '@phosphor-icons/react';
import { useCardTerminal } from '../lib/cardTerminal';

const ICONS = { cash: Money, card: CreditCard, credits: Coins, invoice: Receipt, waive: HandHeart };

// Tap-to-choose payment method dialog. `request` = { title, subtitle, methods:[{key,label}] } or null.
export const PaymentMethodPicker = ({ request, onPick, onClose, cancelLabel }) => {
  const [busy, setBusy] = useState(false);
  const terminal = useCardTerminal();
  const pick = async (m) => {
    setBusy(true);
    try { await onPick(m); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!request} onOpenChange={(o) => { if (!o && !busy) onClose(); }}>
      <DialogContent className="max-w-sm" data-testid="payment-method-picker">
        <DialogHeader>
          <DialogTitle>{request?.title}</DialogTitle>
          {request?.subtitle && <DialogDescription>{request.subtitle}</DialogDescription>}
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3 mt-2">
          {(request?.methods || []).map((m, i) => {
            const Icon = ICONS[m.key] || Money;
            const primary = i < 2;
            return (
              <button key={m.key} type="button" disabled={busy} onClick={() => pick(m)}
                data-testid={`pay-method-${m.key}`}
                className={`flex flex-col items-center justify-center gap-1.5 rounded-xl border-2 font-bold transition-colors disabled:opacity-50 ${primary ? 'py-6 text-base border-emerald-600 bg-emerald-600 text-white hover:bg-emerald-700' : 'py-3 text-sm border-slate-200 bg-white text-slate-700 hover:bg-slate-50'}`}>
                <Icon size={primary ? 28 : 20} weight="bold" />
                {m.label}
              </button>
            );
          })}
        </div>
        {(request?.methods || []).some((m) => m.key === 'card') && (
          <p className={`text-[11px] text-center ${terminal?.connected ? 'text-emerald-700' : 'text-amber-700'}`} data-testid="pay-method-terminal-hint">
            {terminal?.connected ? 'Karte geht direkt ans Kartenterminal.' : terminal?.paired ? 'Kartenterminal getrennt – verbindet neu…' : 'Kein Kartenterminal an diesem Gerät gekoppelt – Karte wird nur erfasst. (Kasse → "Terminal koppeln")'}
          </p>
        )}
        <Button variant="outline" onClick={onClose} disabled={busy} className="w-full mt-2" data-testid="pay-method-cancel">
          {cancelLabel}
        </Button>
      </DialogContent>
    </Dialog>
  );
};
